import { render } from "./searchsecondaryStudents.vue?vue&type=template&id=2819928b&scoped=true"
import script from "./searchsecondaryStudents.vue?vue&type=script&lang=js"
export * from "./searchsecondaryStudents.vue?vue&type=script&lang=js"

import "./searchsecondaryStudents.vue?vue&type=style&index=0&id=2819928b&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2819928b"]])

export default __exports__